import { render } from "./Adfs.vue?vue&type=template&id=33a0df6e&scoped=true"
import script from "./Adfs.vue?vue&type=script&lang=js"
export * from "./Adfs.vue?vue&type=script&lang=js"

import "./Adfs.vue?vue&type=style&index=0&id=33a0df6e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a0df6e"]])

export default __exports__